import { css } from 'styled-components';

export default css`
  margin-top: 124px;
  margin-bottom: 124px;
  @media ${(props) => props.theme.mediaQuery.large} {
    margin-top: 120px;
    margin-bottom: 169px;
  }
  & .breadcrumbs {
    padding: 0px;
    list-style: none;
  }
  & .breadcrumbs .breadcrumb {
    display: inline;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    font-style: normal;
  }
  & .breadcrumb:last-child a {
    font-weight: 700 !important;
  }
  & .breadcrumbs .breadcrumb:not(:last-child)::after {
    padding: 0px 16px;
    font-weight: 400;
    color: black;
    content: '/';
  }

  & .breadcrumbs .breadcrumb a {
    color: #000000;
    font-weight: 400;
    font-size: 14px;
    text-decoration: none;
  }

  & .disable-overflow {
    display: inline !important;
  }
  & .enable-overflow {
    display: none !important;
  }

  @media only screen and (max-width: 767px) {
    & .breadcrumbs .breadcrumb:not(:last-child)::after {
      padding: 0px 8px;
    }

    .disable-overflow {
      display: none !important;
    }

    .enable-overflow {
      padding-right: 8px;
      display: inline !important;
    }
  }
  & .visible {
    display: inline !important;
  }
  & .not-visible {
    display: none !important;
  }
`;
